import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import '../assets/styles/menu.css'

export default function Menu() {
    const navigate = useNavigate();
    const { day } = useParams();
    return (
        <div className="homepage-container">
        <div className="header">
        <div className="back-arrow" onClick={() => navigate("/homepage")}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M15 18L9 12L15 6" stroke="#CCA4CC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
            <h1 className="day-title">Day {day}</h1>
        </div>
        <div className="button-frame">
            <button className="button-kehadiran" onClick={() => navigate(`/kehadiran/${day}`)}>Kehadiran</button>
            <button className="button-kepulangan" onClick={() => navigate(`/kepulangan/${day}`)}>Kepulangan</button>
            <button className="button-games" onClick={() => navigate(`/startgames/${day}`)}>Games</button>
        </div>
        </div>
    );
}
